TS.ns('WL');

WL.scoringCategoryModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this,
            stateList;

        me.parent(config);

        var inputTypeList = me.getDomainProperty('lkpInputType_Property');
        if (inputTypeList != null) {
            inputTypeList.on('selectionChanged', me._onInputTypeChanged, me);
        }

        me.ShowCategoryFormulaField = ko.computed(function () {
            if (me.Document.Computed())
                return true;
            return false;
        });

        me.ShowScaleField = ko.computed(function () {
            if (me.Document.InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC)
                return true;
            return false; 
        });

        me.ShowMinMaxDetailValues = ko.computed(function () {
            if (me.Document.InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC)
                return true;
            return false;
        });

        me.DoNotShowMinMaxDetailValues = ko.computed(function () {
            if (me.Document.InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC)
                return false;
            return true;
        });

    },
    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var scaleList = me.getDomainProperty('DecimalList');
        if (scaleList != null) {
            scaleList.on('selectionChanged', me._onMinMaxChanged, me);
            scaleList.on('selectionChanged', me._onScaleChanged, me);
        }        
    },
   
    _onInputTypeChanged: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'InputTypeChanged',
            submitModel: true,
            blockUI: false
        });
    },

    _onScaleChanged: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'NoOfDecimalsChanged',
            submitModel: true,
            blockUI: false
        });
    },

    _onMinMaxChanged: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'RemoveMinMaxColumns',
            submitModel: true,
            blockUI: false
        });
    }
});